import { render, staticRenderFns } from "./DailyStatsByUserView.vue?vue&type=template&id=99e5ae50"
import script from "./DailyStatsByUserView.vue?vue&type=script&lang=js"
export * from "./DailyStatsByUserView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports